import styled from 'styled-components';

export const CollapseWrap = styled.div`
    .ant-collapse {
        background-color: ${props => props.theme.backgroundColor.layoutLight};
        border-radius: 0;
        border: 1px solid ${props => props.theme.border.pill};
    }
    .ant-collapse > .ant-collapse-item {
        border-bottom: none;
        margin: 3px;
    }
    .ant-collapse-content {
        border-top: none;
    }
    .ant-collapse-content > .ant-collapse-content-box {
        @media only screen and (min-width: 768px){
             padding: 10px 30px 20px 30px !important;
        }
        @media only screen and (min-width: 320px) and (max-width: 767px) {
            padding: 0 !important;
        }
    }
    .ant-collapse > .ant-collapse-item > .ant-collapse-header {
        padding: 20px 31px 20px 30px !important;
        @media only screen and (min-width: 320px) and (max-width: 767px) {
            padding: 20px !important;
        }
    }
    &.balanceDetailsSection{
        .ant-collapse-content > .ant-collapse-content-box {
            @media only screen and (min-width: 768px){
                padding: 0px 30px 20px 30px !important;
           }
        }
    }
    
`
export const CollapseContainer = styled.div`
    background-color: ${props => props.theme.backgroundColor.summaryDivider};
    .ant-table-column-title{
        white-space: pre-wrap;
        max-width: 110px;
        top:-2px;
    }
`